import React from "react";
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader";
import { Form } from "../../../components/Form/Form"
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import {createEgressProvider} from '../../../actions/actionEgressProvider';
import EgressProviderForm from "../EgressProviderForm/EgressProviderForm";

const parentRouteList = parentRoutes('/egress_providers')
const newRoutes = [
    ...parentRouteList.routes,
    {name: "generic.create",path:"/create_egress_provider",isActive: true},
];

const tabList = [
    { name: 'generic.create', key: 'form' },
]

export default function CreateEgressProvider(props) {
    const { t } = useTranslation('common');

    const onSuccess = () => {
        props.history.push('/egress_providers');
    }

    return (
        <div>
        <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('egress_provider.create-egress-provider')} icon={<FontAwesomeIcon icon={faArrowProgress} />} />
        <Form 
            {...props}
            tabList={tabList}
            currentTab="form"
            section="egress_provider"
            dispatchFunc={createEgressProvider}
            onSuccess={onSuccess}
            form={<EgressProviderForm {...props} />}
        />
    </div>
    )
}
